import { get, isNil } from 'lodash'
import ApiImage from './ApiImage';

class ApiTextEssay {
	static default = {
		id: "",
		title: "",
		bodyHtml: "",
		images: []
	};

	static id = apiTextEssay => get(apiTextEssay, "id", ApiTextEssay.default.id);

	static title = apiTextEssay => get(apiTextEssay, "title", ApiTextEssay.default.title);

	static bodyHtml = apiTextEssay => get(apiTextEssay, "bodyHtml", ApiTextEssay.default.bodyHtml);

	static images = apiTextEssay => get(apiTextEssay, "images", ApiTextEssay.default.images);

    static imageUrls = apiTextEssay => ApiTextEssay.images(apiTextEssay).map(apiImage => ApiImage.url(apiImage))

    static withPaywall = apiTextEssay => {
        if(isNil(apiTextEssay)) return ApiTextEssay.default
        return {
            ...apiTextEssay,
            bodyHtml: ApiTextEssay.bodyHtml(apiTextEssay).slice(0,2000)
        }
    }
}

export default ApiTextEssay